import { render, staticRenderFns } from "./Ylqx.vue?vue&type=template&id=6bde834e&scoped=true&"
import script from "./Ylqx.vue?vue&type=script&lang=js&"
export * from "./Ylqx.vue?vue&type=script&lang=js&"
import style0 from "./Ylqx.vue?vue&type=style&index=0&id=6bde834e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bde834e",
  null
  
)

export default component.exports